export const version = "bytes/5.0.9";
//# sourceMappingURL=_version.js.map